import { FunctionComponent } from 'react'
import MuiDialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'

const Header: FunctionComponent<HeaderProps> = ({ handleOnClose }: HeaderProps) => (
  <div className='ph8 ph7-t ph6-m relative'>
    <IconButton
      size='small'
      aria-label='close'
      className='sign-up-close-button absolute right4 top4 bluish-grey pa4'
      onClick={handleOnClose}
    >
      <CloseIcon fontSize='small' />
    </IconButton>
    <div className='dib f2 b black lh-headline mt8'>Content Unavailable</div>
    <div className='dib f4 black lh-copy-variant mb6'>This content is not included in your FromCounsel subscription.</div>
  </div>
)

const Footer: FunctionComponent<FooterProps> = ({ isBasicMessage }: FooterProps) => (
  <>
    <div className='sign-up-footer-wrapper mt7 dib w-100'>
      <div className='sign-up-footer-content flex mb8 w-100'>
        <div className='sign-up-footer-title pr3 f5 black w-100'>
          <p>
            Your FromCounsel subscription does not currently include this
            content. To find out about adding this to your service, please
            click <a target='_blank' rel='noopener noreferrer' href='https://solutions.fromcounsel.com/contact-us-existing-subscriber'>here</a> and a member of our
            team will be in touch.
          </p>
          {!isBasicMessage && (
            <p className='i'>
              — To return to your last page, simply click the X above followed by the back button on your browser or
              return to your original browser if the link opened in a new window
            </p>
          )}
        </div>
      </div>
    </div>
  </>
)

const Dialog = styled(MuiDialog)({ '& .MuiDialog-paper': { margin: '0.5rem' } })

const IncorrectUserRoleModal: FunctionComponent<IncorrectUserRoleModalProps> = ({ isOpen, setOpen, isBasicMessage, setIsBasicMessage }) => {
  const handleOnClose = (): void => {
    setOpen(false)
    setIsBasicMessage(false)
  }

  return (
    <Dialog
      open={isOpen}
      onClose={(_, reason) => reason !== 'backdropClick' && handleOnClose()}
    >
      <div className='role-error-overlay bg-white w-100 br1 shadow-8-04 tc z5 ph7'>
        <Header {...{ handleOnClose }} />
        <Footer {...{ isBasicMessage }} />
      </div>
    </Dialog>
  )
}

interface HeaderProps {
  handleOnClose: () => void
}

interface FooterProps {
  isBasicMessage: boolean
}

interface IncorrectUserRoleModalProps {
  isOpen: boolean
  setOpen: (value: boolean) => void
  isBasicMessage: boolean
  setIsBasicMessage: (value: boolean) => void
}

export default IncorrectUserRoleModal
